import {
  OreData,
  OreFormGroup,
  OreHeading,
  OreRadioButton,
  OreStack,
  OreText,
  SvgDestinationDirection,
} from '@edenredespana/oreneta'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { AutoEnrollmentBillingAddressDataModel } from '@/AutoEnrollment/domain'
import { AutoEnrollmentTranslation } from '@/AutoEnrollment/ui/autoEnrollmentTranslation'
import { Step2Form } from '@/AutoEnrollment/ui/hooks'
import { addComma } from '@/Shared/domain'
import { handleErrors } from '@/Shared/ui/form'
import { formTranslation } from '@/Shared/ui/sharedTranslation'

import { useAutoEnrollment } from '../context'

export const Step2WelcomePackAddressData = (): JSX.Element => {
  const { t } = useTranslation()

  const { register, formState, watch } = useFormContext<Step2Form>()
  const { errors } = handleErrors(formState)

  const { autoEnrollmentModel } = useAutoEnrollment()
  const billingAddressData: AutoEnrollmentBillingAddressDataModel =
    autoEnrollmentModel?.billingAddressData ||
    ({} as AutoEnrollmentBillingAddressDataModel)

  return (
    <OreStack placeContent="stretch" space="large">
      <OreHeading as="h2" size="headline-md">
        {t(AutoEnrollmentTranslation.storeWelcomePackData.title)}
      </OreHeading>
      <OreFormGroup direction="row" {...errors('useStoreAddressForWelcomePack')}>
        <OreRadioButton
          label={t(
            AutoEnrollmentTranslation.storeWelcomePackData.data.useStoreAddress.label,
          )}
          value={'true'}
          {...register('useStoreAddressForWelcomePack')}
        />
        <OreRadioButton
          label={t(
            AutoEnrollmentTranslation.storeWelcomePackData.data.useBillingAddress.label,
          )}
          value={'false'}
          {...register('useStoreAddressForWelcomePack')}
        />
      </OreFormGroup>

      {watch('useStoreAddressForWelcomePack') === 'true' ? (
        <>
          <OreText>
            {t(
              AutoEnrollmentTranslation.storeWelcomePackData.data.useStoreAddress
                .helpText,
            )}
          </OreText>
          <OreData
            icon={<SvgDestinationDirection />}
            title={t(formTranslation.common.address.address)}
            description={
              addComma(watch('storeStreet')) +
              addComma(watch('storeNumber')) +
              addComma(watch('storeFloorBlockStair')) +
              addComma(watch('storePostalCode')) +
              addComma(watch('storeCity')) +
              watch('storeProvince') +
              '. ' +
              watch('storeAdditionalInfo')
            }
          />
        </>
      ) : (
        <>
          <OreText>
            {t(
              AutoEnrollmentTranslation.storeWelcomePackData.data.useBillingAddress
                .helpText,
            )}
          </OreText>
          {billingAddressData && (
            <OreData
              icon={<SvgDestinationDirection />}
              title={t(formTranslation.common.address.address)}
              description={
                addComma(billingAddressData.street) +
                addComma(billingAddressData.number) +
                addComma(billingAddressData.floorBlockStair) +
                addComma(billingAddressData.postalCode) +
                addComma(billingAddressData.city) +
                billingAddressData.province +
                '. ' +
                billingAddressData.additionalInfo
              }
            />
          )}
        </>
      )}
    </OreStack>
  )
}
